import { render } from "./WorkspaceSubmenu.vue?vue&type=template&id=2c0b9a61"
import script from "./WorkspaceSubmenu.vue?vue&type=script&lang=js"
export * from "./WorkspaceSubmenu.vue?vue&type=script&lang=js"

import "./WorkspaceSubmenu.vue?vue&type=style&index=0&id=2c0b9a61&lang=css"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__